import { gql } from '@apollo/client';

export const SUBMIT_ETS_ATTEMPT = gql`
  mutation SubmitETSAttempt($input: SubmitETSAttemptInput!) {
    submitETSAttempt(input: $input) {
      _id
      type
      etsTraitScores {
        focus
        resilience
        discipline
        coachability
        competitiveness
      }
      gScore
      dateTaken
    }
  }
`;